import { ArchivoService } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const ArchivoManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();
  const grabar = (archivos) => {
    return ArchivoService.grabar(archivos).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };
  const listado = (where) => {
    return ArchivoService.listado(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };
  const inactivarArchivo = (Id) => {
    return service.inactivarArchivo(Id).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const descargarPorId = (id) => {
    return ArchivoService.descargarPorId(id).then((res) => {
      return res;
    });
  };

  const listarDocumentos = (where) => {
    return ArchivoService.listarDocumentos(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const adjuntarDocumentos = (documentos) => {
    return ArchivoService.adjuntarDocumentos(documentos).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const descargarDocumentoPorId = (args) => {
    return ArchivoService.descargarDocumentoPorId(args).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.blob;
    });
  };

  const borrarDocumentoPorId = (id) => {
    return ArchivoService.borrarDocumentoPorId(id).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  return {
    grabar,
    listado,
    descargarPorId,
    listarDocumentos,
    adjuntarDocumentos,
    descargarDocumentoPorId,
    borrarDocumentoPorId,
    inactivarArchivo
  };
})();
